export * from './patient-diagnosis.service';